import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Formik, Form, Field, ErrorMessage } from "formik";
// --- Import components
import Button from "../../../../components/UI/Button/Button";
// --- Import images
import eyeHidden from "../../../../assets/images/restore_password/icon_eye.svg";
import eyeVisible from "../../../../assets/images/restore_password/icon_eye_true.svg";

import style from "./RestorePasswordFrom.module.sass";

function RestorePasswordForm({
  data,
  hasError,
  setParams,
  setUpdatedSuccessfully,
  uniqueKey,
}) {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isRepeatPasswordVisible, setIsRepeatPasswordVisible] = useState(false);

  // --- Form validation
  const validateRestorePasswordForm = (values) => {
    const errors = {};

    const re = /(?=.*[0-9])(?=.*[a-z])[0-9a-zA-Z!@#$%^&*]{6,}/g;
    if (!values.password) {
      errors.password = "Required";
    } else if (!re.test(values.password)) {
      errors.password = "Password must contain numbers and letters";
    } else if (values.password !== values.repeatPassword) {
      errors.repeatPassword = "Password mismatch";
    }
    return errors;
  };

  // --- Password update request
  const onSubmitForm = (values) => {
    setParams({
      c: "accountStore",
      a: "setPassword",
      p: { aPassword: values.password, key: uniqueKey },
    });
  };

  // --- Password updated successfully
  useMemo(() => {
    if (data && !hasError) {
      setUpdatedSuccessfully(true);
    }
  }, [data]);

  // --- Change the state of the field type to view the password
  const onViewPassword = () => {
    if (isPasswordVisible) {
      setIsPasswordVisible(false);
    } else {
      setIsPasswordVisible(true);
    }
  };

  const onViewRepeatPassword = () => {
    if (isRepeatPasswordVisible) {
      setIsRepeatPasswordVisible(false);
    } else {
      setIsRepeatPasswordVisible(true);
    }
  };

  return (
    <Formik
      initialValues={{ password: "", repeatPassword: "" }}
      validate={(values) => validateRestorePasswordForm(values)}
      onSubmit={(values) => onSubmitForm(values)}
    >
      {({ isSubmitting }) => (
        <>
          <Form className={style.restorePasswordForm}>
            {/* New password field */}
            <div className={style.newPassField}>
              <Field
                type={isPasswordVisible ? "text" : "password"}
                name="password"
                placeholder="New Password"
                className="input"
              />
              <span
                role="presentation"
                onClick={() => onViewPassword()}
                className={
                  isPasswordVisible ? style.eyeHidden : style.eyeVisible
                }
              >
                <img src={isPasswordVisible ? eyeVisible : eyeHidden} alt="" />
              </span>

              <ErrorMessage
                className={style.error}
                name="password"
                component="div"
              />
            </div>
            {/* Repeat password field */}
            <div className={style.repeatPassField}>
              <Field
                type={isRepeatPasswordVisible ? "text" : "password"}
                name="repeatPassword"
                placeholder="Repeat Password"
                className="input"
              />
              <span
                role="presentation"
                onClick={() => onViewRepeatPassword()}
                className={
                  isRepeatPasswordVisible ? style.eyeHidden : style.eyeVisible
                }
              >
                <img
                  alt=""
                  src={isRepeatPasswordVisible ? eyeVisible : eyeHidden}
                />
              </span>
              <ErrorMessage
                className={style.error}
                name="repeatPassword"
                component="div"
              />
            </div>
            <Button
              className={`btn-primary ${style.btnUpdatePass}`}
              disabled={isSubmitting}
              type="submit"
            >
              Restore my password
            </Button>
          </Form>
        </>
      )}
    </Formik>
  );
}

RestorePasswordForm.propTypes = {
  data: PropTypes.string,
  hasError: PropTypes.bool,
  setParams: PropTypes.func,
  setUpdatedSuccessfully: PropTypes.func,
  uniqueKey: PropTypes.string,
};
RestorePasswordForm.defaultProps = {
  data: null,
  hasError: false,
  uniqueKey: "",
  setParams: () => {},
  setUpdatedSuccessfully: () => {},
};

export default RestorePasswordForm;
